import { CandidateOpportunitiesConst, WeeklyTimeUnits } from '@axiom/const';
import sortBy from 'lodash/sortBy';

export const PositionUtil = {
  getFulfillmentStatus() {
    // eslint-disable-next-line unicorn/no-unreadable-iife
    return (({ Selected, Engaged, Completed }) => ({
      Selected,
      Engaged,
      Completed,
    }))(CandidateOpportunitiesConst.CandidateStatuses);
  },

  isCandidateStatusFulfilled(candidateStatus) {
    return !!this.getFulfillmentStatus()[candidateStatus];
  },

  isPositionFulfilled(candidates = []) {
    return !!candidates.some(candidate =>
      this.isCandidateStatusFulfilled(candidate.candidateStatus)
    );
  },

  sortPositions(positions) {
    return sortBy(positions, ['createdAt', 'id']);
  },

  calculatePositionHoursPerWeek(position) {
    return position.weeklyTimeUnit === WeeklyTimeUnits.Hourly
      ? position.billingUnitsPerWeek
      : position.billingUnitsPerWeek * position.billingHoursPerDay;
  },

  getNameLabel({ prefix = 'position', position, ordinal = 1 }) {
    return `${position.name ? `${position.name}` : `${prefix} ${ordinal}`}`;
  },

  isCandidateOnPosition(positions, candidateId) {
    return (
      Array.isArray(positions) &&
      positions.some(p => p.candidates.find(pc => pc.id === candidateId))
    );
  },
};
